import React, {Component} from 'react'
import * as PropTypes from "prop-types";
import {URL_REDIRECT_AFFILIATE} from "../constants/Url";
import {getDhcNo} from "./Util";

const DHCAffiliateComponent = (props) => {
  return <div className="sect">
    <h2>検査結果に対応したオーダーメイド感覚のサプリメント</h2>
    <div className="row">
      <div className="col">
        <img src="image/nutrition/package.jpg" alt="nutrition"  />
        <div className="img_undertext">※画像はイメージです</div>
      </div>
      <div className="col textcont">
        <h3>DHCダイエット対策キット対応型サプリ</h3>
        <p className="abovelink_text">「DHCの遺伝子検査 ダイエット対策キット」の結果は、性別と遺伝子型の組み合わせから、りんご型と洋なし型でそれぞれ24パターン、バナナ型で4パターン、アダム・イヴ型で2パターンの全54パターンに体質を細分化し、あなたにおすすめの栄養素を最適なバランスで摂取できるサプリメントです。</p>
        <a onClick={props.onClick}>あなたへのおすすめのサプリはこちら</a>
        <p className="attention_text">※「DHCダイエット対策キット対応型サプリ」は株式会社ディーエイチシーの商品です。DHC遺伝子検査相談室では、対応型サプリの摂取方法や成分などについてのみ、ご案内が可能です。その他、ご自身の検査結果や体質などに関するご相談は、当社へお問い合わせください。</p>
      </div>
    </div>
  </div>
};

DHCAffiliateComponent.propTypes = {onClick: PropTypes.func};

const HealthUp = () => {
  return <div className="sect">
    <h2>パーソナルな食事指導はこちらから</h2>
    <div className="row">
      <div className="col">
        <img src="image/nutrition/taberu.jpg" alt="nutrition" />
      </div>
      <div className="col textcont">
        <h3>食生活のパーソナル分析</h3>
        <p className="abovelink_text">当社の管理栄養士による食事分析・電話カウンセリングサービス。遺伝的な体質にあったパーソナルなアドバイスをご提供いたいます。</p>
        <a href='https://sales.genelife.jp/sales/product/meal' target="_blank">詳しくはこちら</a>
      </div>
    </div>
  </div>
};

const AffiliateLinkModal = (props) => {
    return <div className="c-modal" aria-activedescendant={props.modalShow === true ? "true" : "false"}>
        <div className="c-modal__panel modal_dialog">
            <div className="dialog_header">
              <span onClick={props.onCloseClick} className="dialog_close">×</span>
                <h3>他社のWEBサイトに移動します</h3>
            </div>
            <div id="c-modal__content" className="dialog_content">
            これより先は、外部サイトに移動します。 よろしければ下記ボタンを押してください。
            </div>
            <div className="dialog_bottom">
              <button className="c-btn c-btn-default--flat decline" onClick={props.onCloseClick}>戻る</button>
                <button className="c-btn c-btn-default--flat" onClick={props.onRedirectClick}>続行する</button>
            </div>
        </div>
        <div className="c-modal__overlay" onClick={props.onCloseClick}></div>
    </div>;
};

AffiliateLinkModal.propTypes = {
    modalShow: PropTypes.bool,
    onCloseClick: PropTypes.any,
    onRedirectClick: PropTypes.any
};

export class AffiliateRecommend extends Component {
    constructor(props) {
        super(props);
        // TODO 一時的にいれているだけ
        this.state = {
            modalShow: false
        }
    }


    redirectAffiliateLink () {
        this.setState({modalShow: false})
        // TODO 複数アフィリエイト対応する際には気をつけて
        let dhc_no = getDhcNo(this.props.subtypes);
        window.open(URL_REDIRECT_AFFILIATE(dhc_no), '_blank');
    }

    openAffiliateLink() {
        this.setState({modalShow: true})
    }

    handleClickClose() {
        this.setState({modalShow: false})
    }

    render() {
        return <div className="wrap">

            <AffiliateLinkModal modalShow={this.state.modalShow} onCloseClick={this.handleClickClose.bind(this)}
                                onRedirectClick={this.redirectAffiliateLink.bind(this)}/>

            <DHCAffiliateComponent onClick={() => {
                (this.openAffiliateLink());
            }}/>

            <HealthUp/>


        </div>;
    }
}

AffiliateRecommend.propTypes = {subtypes: PropTypes.array};



// WEBPACK FOOTER //
// ./src/components/AffiliateRecommend.js